"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.scanQrCode = scanQrCode;
exports.openPermissionsSettings = openPermissionsSettings;
exports.getQRScannerStatus = getQRScannerStatus;
exports.USER_CANCELED = exports.DENIAL_STATES = void 0;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _react = _interopRequireDefault(require("react"));

var _QRScannerOverlay = _interopRequireDefault(require("../common/components/QRScannerOverlay/QRScannerOverlay"));

var _SysMessageHelper = require("./SysMessageHelper");

var _AppUtils = require("../utils/AppUtils");

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _EncrpytionHelper = require("./EncrpytionHelper");

var _MuiAlertHelper = require("./MuiAlertHelper");

var _strings = require("../common/components/QRScannerOverlay/strings");

var _ErrorHelper = require("./ErrorHelper");

var _ResumeSuspendListeners = require("./ResumeSuspendListeners");

var _FullscreenOverlay = _interopRequireDefault(require("../common/components/FullscreenOverlay/FullscreenOverlay.scss"));

var _DeviceInfoHelper = _interopRequireDefault(require("./DeviceInfoHelper"));

var _KesiConstants = require("../KESI2/KesiConstants");

var _DeeplinkHelper = require("./DeeplinkHelper");

var _RegisterInstance = _interopRequireDefault(require("../KESI2/Services/RegisterInstance"));

var _UrlHelper = _interopRequireDefault(require("./UrlHelper"));

var _BuildConstants = require("../utils/BuildConstants");

var _HttpRequest = require("../utils/HttpRequest");

// ID of the DOM element to mount app on
var DOM_QR_SCANNER_ID = 'qrscanner';
var DENIAL_STATES = {
  PERMANENTLY: 'permanently',
  TEMPORARILY: 'temporarily'
};
exports.DENIAL_STATES = DENIAL_STATES;
var QR_CODE_PREFIXES = {
  SYS_MESSAGES: 'eqsmENC',
  SYS_MESSAGES_PLAIN: 'eqsmPLA',
  REFERRER: 'eqref__',
  LINK_MESSAGE: 'eqlink_'
};
var USER_CANCELED = 'user_canceled';
exports.USER_CANCELED = USER_CANCELED;
var localDoneFn = null;
var checkAuthorizedTimeout = null;

function _onDestroy() {
  console.log('qr scanner destroyed');
}

function hideAppAndShowScanner(onCancel) {
  // hide app and show qr code overlays
  document.getElementById('app').style.display = 'none';
  document.querySelectorAll('[role="presentation"]').forEach(function (el) {
    el.style.display = 'none';
  });
  var overlays1 = document.getElementsByClassName(_FullscreenOverlay["default"].root);
  var overlays2 = document.getElementsByClassName(_FullscreenOverlay["default"].rootIE);

  for (var i = 0; i < overlays1.length; i++) {
    overlays1[i].style.display = 'none';
  }

  for (var _i = 0; _i < overlays2.length; _i++) {
    overlays2[_i].style.display = 'none';
  } // Render the router


  _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(_QRScannerOverlay["default"], {
    onCancel: onCancel
  }), document.getElementById(DOM_QR_SCANNER_ID));
}

function hideScannerAndShowApp() {
  // hide qr code overlays and show app
  document.getElementById('app').style.display = '';
  document.querySelectorAll('[role="presentation"]').forEach(function (el) {
    el.style.display = '';
  });
  var overlays1 = document.getElementsByClassName(_FullscreenOverlay["default"].root);
  var overlays2 = document.getElementsByClassName(_FullscreenOverlay["default"].rootIE);

  for (var i = 0; i < overlays1.length; i++) {
    overlays1[i].style.display = '';
  }

  for (var _i2 = 0; _i2 < overlays2.length; _i2++) {
    overlays2[_i2].style.display = '';
  }

  _reactDom["default"].unmountComponentAtNode(document.getElementById(DOM_QR_SCANNER_ID));
}

function _decryptMessage(contents) {
  if (contents && typeof contents === 'string') {
    return (0, _EncrpytionHelper.decryptAES)(_config["default"].qrCodeSymmetricKey, contents);
  }

  return contents;
}

function _scanQrCode(_x, _x2) {
  return _scanQrCode2.apply(this, arguments);
}

function _scanQrCode2() {
  _scanQrCode2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(resolve, reject) {
    var onScan, onShow;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            onScan = /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(err, contents) {
                var contentPlainText, params, token, response, _response, _response$data$sysMes, _response$data$sysMes2, content, json, sysMessages, succesfullyHandled, configMessageId, link, _link$split, _link$split2, path, hash, pathArray;

                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!err) {
                          _context.next = 6;
                          break;
                        }

                        console.error('error reading qr code:', err);
                        hideScannerAndShowApp();
                        reject(err);
                        _context.next = 82;
                        break;

                      case 6:
                        console.log('scanned qr code with contents is:', contents);
                        hideScannerAndShowApp();
                        window.QRScanner.destroy(_onDestroy);

                        if (!(contents.startsWith(QR_CODE_PREFIXES.SYS_MESSAGES) || contents.startsWith(QR_CODE_PREFIXES.SYS_MESSAGES_PLAIN) || contents.startsWith('https://'))) {
                          _context.next = 60;
                          break;
                        }

                        _context.prev = 10;

                        if (!contents.startsWith(QR_CODE_PREFIXES.SYS_MESSAGES)) {
                          _context.next = 15;
                          break;
                        }

                        contentPlainText = _decryptMessage(contents.substring(QR_CODE_PREFIXES.SYS_MESSAGES.length));
                        _context.next = 42;
                        break;

                      case 15:
                        if (!contents.startsWith('https://')) {
                          _context.next = 41;
                          break;
                        }

                        params = _UrlHelper["default"].getUrlParams(contents);
                        console.log('params: ', params);
                        _context.next = 20;
                        return _RegisterInstance["default"].getAccessToken('dataStore:read');

                      case 20:
                        token = _context.sent;
                        console.log('token: ', token);
                        response = null;
                        _context.prev = 23;
                        _context.next = 26;
                        return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.AUTH_HOST, "/rest/api/v1/dataStore/configMessages/").concat(params.id), null, null, null, null, "Bearer ".concat(token), null, null, true);

                      case 26:
                        response = _context.sent;
                        _context.next = 33;
                        break;

                      case 29:
                        _context.prev = 29;
                        _context.t0 = _context["catch"](23);
                        console.log(_context.t0);

                        if (_context.t0.message.startsWith('ERROR_HTTP_STATUS_messages')) {
                          window.alert((0, _strings.getString)('QR_INVALID'));
                          console.log('catched an error: ', _context.t0);
                        }

                      case 33:
                        _context.prev = 33;
                        console.log('response: ', response);
                        _response = response, _response$data$sysMes = (0, _slicedToArray2["default"])(_response.data.sysMessages, 1), _response$data$sysMes2 = _response$data$sysMes[0], content = _response$data$sysMes2 === void 0 ? {} : _response$data$sysMes2;
                        contentPlainText = (0, _stringify["default"])(content);
                        console.log(contentPlainText);
                        return _context.finish(33);

                      case 39:
                        _context.next = 42;
                        break;

                      case 41:
                        contentPlainText = contents.substring(QR_CODE_PREFIXES.SYS_MESSAGES_PLAIN.length);

                      case 42:
                        if (contentPlainText) {
                          _context.next = 45;
                          break;
                        }

                        reject(new Error('qr code has no content or we failed to decipher it (if it was encrypted)'));
                        return _context.abrupt("return");

                      case 45:
                        json = JSON.parse(contentPlainText);
                        console.log('json', json);
                        sysMessages = (0, _isArray["default"])(json) ? json : [json];
                        console.log('json', sysMessages);
                        _context.next = 51;
                        return (0, _SysMessageHelper.handleSysMessages)((0, _AppUtils.getAppInstance)(), sysMessages);

                      case 51:
                        succesfullyHandled = _context.sent;
                        console.log('succesfully handled', succesfullyHandled);
                        _context.next = 58;
                        break;

                      case 55:
                        _context.prev = 55;
                        _context.t1 = _context["catch"](10);
                        console.error('error parsing or handling json from qr code', _context.t1);

                      case 58:
                        _context.next = 79;
                        break;

                      case 60:
                        if (!contents.startsWith(QR_CODE_PREFIXES.REFERRER)) {
                          _context.next = 78;
                          break;
                        }

                        configMessageId = contents.substring(QR_CODE_PREFIXES.REFERRER.length);
                        _context.prev = 62;

                        if (!(0, _AppUtils.getAppInstance)().automaticQdLogin) {
                          _context.next = 68;
                          break;
                        }

                        _context.next = 66;
                        return (0, _AppUtils.getAppInstance)().automaticQdLogin(configMessageId, true);

                      case 66:
                        _context.next = 70;
                        break;

                      case 68:
                        _context.next = 70;
                        return (0, _AppUtils.getAppInstance)().retrieveAndHandleConfigMessages(configMessageId);

                      case 70:
                        _context.next = 76;
                        break;

                      case 72:
                        _context.prev = 72;
                        _context.t2 = _context["catch"](62);
                        console.error('get sysmessages from server', configMessageId);
                        reject(_context.t2);

                      case 76:
                        _context.next = 79;
                        break;

                      case 78:
                        if (contents.startsWith(QR_CODE_PREFIXES.LINK_MESSAGE)) {
                          link = contents.substring(QR_CODE_PREFIXES.LINK_MESSAGE.length);
                          _link$split = link.split('#'), _link$split2 = (0, _slicedToArray2["default"])(_link$split, 2), path = _link$split2[0], hash = _link$split2[1];
                          pathArray = path ? path.split(_KesiConstants.KESI_PATH_DELIMITER) : [];
                          (0, _DeeplinkHelper.goToContent)(pathArray, hash);
                        } else {
                          (0, _MuiAlertHelper.showAlertWithOptions)({
                            message: (0, _strings.getString)('QR_UNKNOWN_CONTENT')
                          });
                        }

                      case 79:
                        console.log('localDoneFn', localDoneFn);

                        if (localDoneFn) {
                          localDoneFn();
                        }

                        resolve(contents);

                      case 82:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[10, 55], [23, 29, 33, 39], [62, 72]]);
              }));

              return function onScan(_x4, _x5) {
                return _ref.apply(this, arguments);
              };
            }();

            onShow = function onShow(status) {
              console.info('status of QRScanner.show() is ', status);

              if (status.scanning && status.showing) {
                hideAppAndShowScanner(function () {
                  hideScannerAndShowApp();
                  window.QRScanner.destroy(_onDestroy);
                  reject(new Error(USER_CANCELED));
                });
              }
            };

            console.log('going to scan qr code');
            window.QRScanner.scan(onScan);
            window.QRScanner.show(onShow);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _scanQrCode2.apply(this, arguments);
}

function _showAlertToOpenSettings() {
  var cancelButton = {
    label: (0, _strings.getString)('CANCEL')
  };
  var openPermissionsButton = {
    label: (0, _strings.getString)('OPEN_CAMERA_SETTINGS'),
    callback: window.QRScanner.openSettings
  };
  (0, _MuiAlertHelper.showAlertWithOptions)({
    title: (0, _strings.getString)('ERROR'),
    message: (0, _strings.getString)('QR_PERMISSION_DENIED_OPEN_SETTINGS'),
    showCloseButton: false,
    buttons: [cancelButton, openPermissionsButton]
  });
}
/**
 * Unless already granted, the user is requested for camera permission. Only one chance on iOS.
 *
 * All the app will be transparent while scanning a QR Code
 */


function scanQrCode(_x3) {
  return _scanQrCode3.apply(this, arguments);
}

function _scanQrCode3() {
  _scanQrCode3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(doneFn) {
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            clearTimeout(checkAuthorizedTimeout);
            return _context5.abrupt("return", new _promise["default"]( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(resolve, reject) {
                var suspendListener, onCameraPermissionGrantedOrDenied, status, afterTimeout;
                return _regenerator["default"].wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        suspendListener = (0, _ResumeSuspendListeners.addOnSuspendListener)(function () {
                          (0, _ResumeSuspendListeners.removeOnSuspendListener)(suspendListener);
                          hideScannerAndShowApp();
                          window.QRScanner.destroy();
                          reject(new Error('app suspended'));
                        });
                        localDoneFn = doneFn;

                        onCameraPermissionGrantedOrDenied = function onCameraPermissionGrantedOrDenied(err, status) {
                          if (err) {
                            if (err.name === 'CAMERA_ACCESS_DENIED') {
                              _showAlertToOpenSettings();

                              return;
                            }

                            console.error('error getting camera permission:', err, status);
                            (0, _MuiAlertHelper.showAlertWithOptions)({
                              title: (0, _strings.getString)('ERROR'),
                              message: (0, _ErrorHelper.getErrorMessage)(err)
                            });
                            reject(err);
                          } else if (status.authorized) {
                            console.info('the user authorized the camera usage');

                            _scanQrCode(resolve, reject);
                          } else if (status.denied) {
                            // The video preview will remain black, and scanning is disabled. We can
                            // try to ask the user to change their mind, but we'll have to send them
                            // to their device settings with `QRScanner.openSettings()`.
                            console.info('the user denied access to the camera permanently');
                            reject(DENIAL_STATES.PERMANENTLY);
                          } else {
                            // we didn't get permission, but we didn't get permanently denied. (On
                            // Android, a denial isn't permanent unless the user checks the "Don't
                            // ask again" box.) We can ask again at the next relevant opportunity.
                            console.info('the user denied access to the camera temporarily');
                            reject(DENIAL_STATES.TEMPORARILY);
                          }
                        };

                        _context4.next = 5;
                        return getQRScannerStatus();

                      case 5:
                        status = _context4.sent;

                        if (!status.denied) {
                          _context4.next = 9;
                          break;
                        }

                        _showAlertToOpenSettings();

                        return _context4.abrupt("return");

                      case 9:
                        /**
                         * On Android, we don't get a callback if at this very moment the camera access is not granted.
                         * This means, either the user accepts or denies the permission request, we don't go on.
                         * With this loop, however, we can check if the user has done anything and can go on "manually".
                         */
                        if (_DeviceInfoHelper["default"].isAndroid()) {
                          afterTimeout = /*#__PURE__*/function () {
                            var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                              var nextStatus;
                              return _regenerator["default"].wrap(function _callee3$(_context3) {
                                while (1) {
                                  switch (_context3.prev = _context3.next) {
                                    case 0:
                                      _context3.next = 2;
                                      return getQRScannerStatus();

                                    case 2:
                                      nextStatus = _context3.sent;

                                      if (nextStatus.authorized && !status.authorized) {
                                        _scanQrCode(resolve, reject);
                                      } else if (!nextStatus.denied) {
                                        status = nextStatus;
                                        checkAuthorizedTimeout = setTimeout(afterTimeout, 500);
                                      }

                                    case 4:
                                    case "end":
                                      return _context3.stop();
                                  }
                                }
                              }, _callee3);
                            }));

                            return function afterTimeout() {
                              return _ref3.apply(this, arguments);
                            };
                          }();

                          checkAuthorizedTimeout = setTimeout(afterTimeout, 500);
                        } // ask for camera permission


                        window.QRScanner.prepare(onCameraPermissionGrantedOrDenied);

                      case 11:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x6, _x7) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _scanQrCode3.apply(this, arguments);
}

function openPermissionsSettings() {
  window.QRScanner.openSettings();
}
/**
 *
 * @returns {Promise<{
    "authorized": Boolean
    "denied": Boolean
    "restricted": Boolean
    "prepared": Boolean
    "scanning": Boolean
    "previewing": Boolean
    "showing": Boolean
    "lightEnabled": Boolean
    "canOpenSettings": Boolean
    "canEnableLight": Boolean
    "currentCamera": Number
  }>}
 */


function getQRScannerStatus() {
  return _getQRScannerStatus.apply(this, arguments);
}

function _getQRScannerStatus() {
  _getQRScannerStatus = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", new _promise["default"](function (resolve, reject) {
              window.QRScanner.getStatus(resolve);
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getQRScannerStatus.apply(this, arguments);
}